'use client';

import { Dialog } from '@/_components';
import { useContext, useEffect, type FC } from 'react';
import { CreateEntityForm } from './_components/CreateEntityForm';
import { SelectUser } from './_components/SelectUser';
import { CompanyContext } from '@/_contexts/admin/CompanyProvider';
import type { CreateEntityDialogProps } from './CreateEntityDialog.types';

export const CreateEntityDialog: FC<CreateEntityDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const { selectedUser, selectedClient, setSelectedUser } =
    useContext(CompanyContext);

  useEffect(() => {
    if (!isOpen) {
      setSelectedUser(undefined);
    }
  }, [isOpen, setSelectedUser]);

  const hasSelectedUser: boolean = Boolean(
    selectedClient?.id || selectedUser?.id,
  );

  return (
    <Dialog
      isOpen={isOpen}
      isOverflowing={true}
      isNarrow={!hasSelectedUser}
      onClose={onClose}
      title={
        hasSelectedUser
          ? `Create a new entity for ${selectedUser?.full_name || selectedClient?.full_name}`
          : 'Select User for new Entity'
      }
    >
      <Dialog.Content>
        {hasSelectedUser ? (
          <CreateEntityForm isOpen={isOpen} onClose={onClose} />
        ) : (
          <SelectUser onClose={onClose} />
        )}
      </Dialog.Content>
    </Dialog>
  );
};
